import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const cscCompareCheckbox = {
  backgroundColor: css`var(--csc-compare-checkbox-background-color, var(--cs-form-control-background-color, ${csColorBackground.primary}))`,
}

export const style: CSSResult = css`
	.csc-compare-checkbox {
		width: fit-content;
	}

  .csc-compare-checkbox.has-background {
		background-color: ${cscCompareCheckbox.backgroundColor};
		padding-block: ${csSpacing.spacing02};
		padding-inline: ${csSpacing.spacing04};
		border-radius: ${csSpacing.spacing01};
	}

	cse-checkbox {
		display: flex;
	}
`
